import React from 'react';
import { connect } from 'react-redux';
import properties from '../../constants/Properties';
import availableFonts from '../../constants/AvailableFonts';
import { changeTextProperties, updateCurrentSlideThumbnail } from '../../actions/CurrentSlideActions';
import { expandFontsList } from '../../actions/MenuActions';
import storeManager from '../../store/StoreManager';
import textSizeUtils from '../utils/TextSizeUtils';
import platformDetection from '../utils/PlatformDetection';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import mouseUtils from '../../components/utils/MouseUtils';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import locales from '../../locales/LocalesManager';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            clientX: 0,
            clientY: 0
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onMouseDown(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        const clientPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            clientX: clientPosition.x,
            clientY: clientPosition.y
        });
    },
    onMouseUp(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.changeTextProperties();
    },
    onButtonClick() {
        var downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.changeTextProperties();
    },
    updateThumbnail() {
        this.props.dispatch(updateCurrentSlideThumbnail(true));
    },
    changeTextProperties() {
        if (this.props.executeCommand) {
            this.props.executeCommand(14, this.props.value);
            return;
        }

        this.props.dispatch(changeTextProperties(this.props.shapeModel,'fontFamily', this.props.value));
        audioEditorUtils.addActionToHistory();
        this.updateThumbnail();
        saveManager.isContentChanged(true);
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.shapeModel != newProps.shapeModel || this.props.selectedIndex != newProps.selectedIndex || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        var iconColor;
        var buttonColor;

        if (this.state.isOver == true) {
            iconColor = properties.CONTEXT_HOVER_COLOR;
            buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
        } else {
            iconColor = 'black';
            buttonColor = properties.SLIDE_MENU_COLOR;
        }

        var topPosition = this.props.index * properties.EFFECTS_BUTTON_HEIGHT;

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.accordionWidth - 3 * properties.EFFECTS_PADDING  - 2 * 14,
            height: properties.EFFECTS_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: properties.BROWSER_LEFT_PADDING / 2,
            top: topPosition,
            color: 'white',
            borderStyle: 'none'
        };

        var spanStyle = {
            color: iconColor,
            cursor: 'default',
            fontSize: 20,
            fontFamily: this.props.value,
            top: 0
        };

        var iconVisible;

        if (this.props.index == this.props.selectedIndex)
            iconVisible = 'block';
        else
            iconVisible = 'none';

        const iconStyle = {
            position: 'absolute',
            top: 13,
            right: 10,
            color: iconColor,
            display: iconVisible
        };

        if (platformDetection.isIOS() == true) {
            spanStyle.fontSize = 18;
        }

        return (
            <button aria-label={this.props.value} style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onButtonClick} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp}>
                <span style={spanStyle}>{this.props.value}</span>
                <i style={iconStyle} className='fa fa-check'></i>
            </button>
        );
    }
});

export const FontsSelectorContent = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onExpand (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const isExpanded = !this.props.fontsListIsExpanded;
        this.props.dispatch(expandFontsList(isExpanded));
    },
    onListChanged (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        setTimeout(this.refreshView, 6);
    },
    checkSize() {
        if (this.props.isRichTextEditor)
            return;

        const shapeModel = this.getCurrentShape();

        textSizeUtils.updateTextWrapperSize(shapeModel, this.props.dispatch);
    },
    refreshView() {
        this.checkSize();
        this.forceUpdate();
    },
    getCurrentShape() {
        if (this.props.isRichTextEditor)
            return undefined;

        const state = storeManager.getState();
        const uuid = this.props.contextTarget.uuid;
        const shapes = state.currentSlide.model.content;
        var i;
        var target;

        for (i=0; i<shapes.length; i++) {
            if (shapes[i].uuid == uuid) {
                target = shapes[i];
                break;
            }
        }

        return target;
    },
    getCurrentFontFamily() {
        if (this.props.fontName)
            return this.props.fontName;

        const target = this.getCurrentShape();

        if (target)
            return target.fontFamily;
        else {
            return 'Sniglet';
        }

    },
    getFontsDataProvider () {
        return availableFonts.getAvailableFonts();
    },
    getCurrentFontTopPosition(currentFont) {
        var top = 7;

        switch(currentFont) {
            case 'Sriracha': {
                top = 0;
                break;
            }

            case 'Shrikhand': {
                top = 4;
                break;
            }

            case 'PermanentMarker': {
                top = 3;
                break;
            }

            case 'Peralta': {
                top = 5;
                break;
            }

            case 'CaveatBrush': {
                top = 5;
                break;
            }

            case 'Bangers': {
                top = 8;
                break;
            }

            case 'ArchitectsDaughter': {
                top = 5;
                break;
            }

            case 'Anton': {
                top = 3;
                break;
            }

            case 'AlfaSlabOne': {
                top = 5;
                break;
            }

            case 'BungeeShade': {
                if (platformDetection.isChromeBook())
                    top = 0;
                else
                    top = -8;
                break;
            }
        }

        return top;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.fontsListIsExpanded != newProps.fontsListIsExpanded || this.props.contextTarget != newProps.contextTarget || this.props.fontName != newProps.fontName)
            return true;
        else
            return false;
    },
    render() {
        const currentFontFamily = this.getCurrentFontFamily();
        var height = properties.EFFECTS_BUTTON_HEIGHT + 2;

        var visibleItems = 10;

        if (platformDetection.isIOS() || platformDetection.isMac())
            visibleItems = 15;

        if (this.props.fontsListIsExpanded == true)
            height = height + visibleItems * properties.EFFECTS_BUTTON_HEIGHT + 4;

        var fontsStyle = {
            position: 'absolute',
            top: this.props.top,
            left: 0,
            width: this.props.accordionWidth,
            height: height,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white',
            zIndex: 10000
        };

        if (this.props.isRichTextEditor)
            fontsStyle.backgroundColor = '#BDC5C8';

        var borderColor;
        var textColor;

        if (this.state.isOver == true) {
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            textColor = borderColor;
        } else {
            borderColor = 'black';
            textColor = 'black';
        }

        const fontsButtonStyle = {
            width: this.props.accordionWidth - 2 * properties.EFFECTS_PADDING,
            height: properties.EFFECTS_BUTTON_HEIGHT,
            background: 'white',
            borderRadius: 50,
            position: 'absolute',
            left: properties.EFFECTS_PADDING,
            top: 0,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            alignItems: 'center',
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            textAlign: 'left'
        };

        var icon;

        if (this.props.fontsListIsExpanded == true)
            icon = 'fa fa-angle-down';
        else
            icon = 'fa fa-angle-right';

        const fontsIconStyle = {
            position: 'absolute',
            top: 12,
            right: 21,
            color: textColor
        };

        var spanStyle = {
            position: 'absolute',
            color: textColor,
            cursor: 'default',
            fontSize: 21,
            top: this.getCurrentFontTopPosition(currentFontFamily),
            paddingLeft: 20,
            fontFamily: currentFontFamily
        };

        var elements = [];
        var listDisplay;
        var dataProvider;

        if (this.props.fontsListIsExpanded == true) {
            var i;
            dataProvider = this.getFontsDataProvider();
            var selectedIndex = -1;

            for (i=0; i<dataProvider.length; i++) {
                if (currentFontFamily == dataProvider[i])
                    selectedIndex = i;

                elements.push(<Button executeCommand={this.props.executeCommand} accordionWidth={this.props.accordionWidth} index={i} dispatch={this.props.dispatch} shapeModel={this.props.contextTarget} key={'font' + dataProvider[i]} value={dataProvider[i]} selectedIndex={selectedIndex}/>);
            }

            listDisplay = 'block';
        }   else {
            listDisplay = 'none';
        }

        const fontsListStyle = {
            position: 'absolute',
            width: this.props.accordionWidth - 2 * properties.EFFECTS_PADDING - 2 * properties.EFFECTS_CORNER_GAP + 2,
            height: properties.EFFECTS_BUTTON_HEIGHT * visibleItems,
            top: properties.EFFECTS_BUTTON_HEIGHT + 2,
            left: properties.EFFECTS_PADDING + properties.EFFECTS_CORNER_GAP,
            borderColor: properties.EFFECTS_BUTTON_BORDER_COLOR,
            borderWidth: 1,
            borderStyle: 'solid',
            display: listDisplay,
            overflowY: 'hidden',
            overflowX: 'hidden'
        };

        var componentProperties = {};
        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = fontsListStyle.width;
        componentProperties.height = fontsListStyle.height;
        componentProperties.scrollHeight = dataProvider != undefined ? dataProvider.length * properties.EFFECTS_BUTTON_HEIGHT : 0;
        componentProperties.top = 0;
        componentProperties.displayState = 'block';
        componentProperties.elements = elements;

        if (platformDetection.isIOS() == true) {
            spanStyle.fontSize = 18;
        }

        return (
            <div id='fontsMenu' style={fontsStyle}>
                <button aria-label={locales.getCaption('fontSelector', 'other')} style={fontsButtonStyle} onTouchEnd={this.onExpand} onClick={this.onExpand} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                    <span style={spanStyle}>{currentFontFamily}</span>
                    <i style={fontsIconStyle} className={icon}></i>
                </button>

                <div style={fontsListStyle} onTouchEnd={this.onListChanged} onClick={this.onListChanged}>
                    <ScrollableComponent componentProperties={componentProperties}/>
                </div>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const fontsListIsExpanded = state.menu.fontsListIsExpanded;

    return {
        fontsListIsExpanded
    };
}

export const FontsSelector = connect(mapStateToProps)(FontsSelectorContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/FontsSelector.js
 **/